import React from 'react'
import './styles.scss'

const UpsellMain2 = () => {
	return (
		<div className="upsell-main2">
			<img src={`images/upsell/upsell2.png`} alt="upsell2" />
			<div className="upsell-main2__line"></div>
		</div>
	)
}

export { UpsellMain2 }
